/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_CursorInputs */

const en_mcphosted_hub_cursor = /** @type {(inputs: Mcphosted_Hub_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cursor — Settings → MCP → Add new MCP server, type http.`)
};

const id_mcphosted_hub_cursor = /** @type {(inputs: Mcphosted_Hub_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cursor — Settings → MCP → Add new MCP server, tipe http.`)
};

/**
* | output |
* | --- |
* | "Cursor — Settings → MCP → Add new MCP server, type http." |
*
* @param {Mcphosted_Hub_CursorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_cursor = /** @type {((inputs?: Mcphosted_Hub_CursorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_CursorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_cursor(inputs)
	return en_mcphosted_hub_cursor(inputs)
});